import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const useCollection = (collectionId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["collection", collectionId],
		queryFn: () => http<CollectionModel>({
			method: "GET",
			url: `/collection/${collectionId}`
		})
	});
};
